module.exports = __webpack_public_path__ + "static/media/1-item-d.12dc1cdd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/men/1-item-d.jpg
// module id = 1155
// module chunks = 33